export default {
    GROUP_ID_TYPES: {
        1: '组织机构代码证',
        2: '税务登记证',
        3: '其他',
        4: '营业执照',
        5: '统一社会信用代码(营业执照)', // 统一社会信用代码
    },
    freeOddsTypes: [
      {key: 1.25, value: '100%赔付'},
      {key: 1.125, value: '90%赔付'},
      {key: 1, value: '80%赔付'}
    ],
    GENDERS: {
        1: '男',
        2: '女'
    },
    insuredHasSocialSecS: {
      0: '无社保',
      1: '有社保'
    },
    ID_TYPES: {
        1: '身份证',
        2: '护照',
        3: '驾驶证',
        4: '港澳台通行证',
        5: '军官证',
        6: '外国人永久居留身份证',
        99: '其他'
    },
    USE_ATTRIBUTE_LIST: [
        {key: '4', value: '营业'},
        {key: '8', value: '非营业'},
    ],
    VEHICLE_LIST: [
        {key: '46', value: '货车'},
        {key: '47', value: '特种车'},
    ],
    VEHICLE_DETSAIL_LIST_HUO: [
      {key: '37', value: '2吨以下货车'},
      {key: '38', value: '2吨（含）至5吨以下货车'},
      {key: '39', value: '5吨（含）至10吨以下货车'},
      {key: '40', value: '10吨（含）以上货车'},
    ],
    VEHICLE_DETSAIL_LIST_TE: [
      {key: '41', value: '特种车一'},
      {key: '42', value: '特种车二'},
      // {key: 43, value: '特种车三'},
      {key: '44', value: '特种车四'},
    ],
    GROUP_NATURE_LIST: [
        {key: 1, value: '国有企业'},
        {key: 2, value: '集体企业'},
        {key: 3, value: '联营企业'},
        {key: 4, value: '股份合作制企业'},
        {key: 5, value: '私营企业'},
        {key: 6, value: '个体户'},
        {key: 7, value: '合伙企业'},
        {key: 8, value: '有限责任公司'},
        {key: 9, value: '股份有限公司'},
        {key: 10, value: '事业单位'},
        {key: 11, value: '国家机关'},
        {key: 12, value: '党政机关'},
    ],
    GROUP_NATURE_LIST_FUBAO: [
      {key: 1, value: '国有企业'},
      {key: 2, value: '集体企业'},
      {key: 3, value: '民营企业'},
      {key: 4, value: '股份制企业'},
      {key: 5, value: '三资企业'},
      {key: 6, value: '政府机构'},
      {key: 7, value: '事业单位'},
      {key: 8, value: '社会团体'},
      {key: 9, value: '其它'},
    ],
    GROUP_NATURE_LIST_GUANGDA: [
      {key: '01', value: '政府机关'},
      {key: '02', value: '事业单位'},
      {key: '03', value: '国有企业'},
      {key: '04', value: '集体企业'},
      {key: '05', value: '民营企业'},
      {key: '06', value: '外资企业'},
      {key: '07', value: '股份制企业'},
      {key: '08', value: '合资企业'},
      {key: '09', value: '其它'},
    ],
    ORDER_DESCS: {
        50: "待确认",
        51: "待审核",
        52: "人核中",
        55: "等待付款",

        // 80: "等待保险公司确认收款",
        80: "付款待确认（对公转账）",

        // 100: "投保中",
        100: "核保中",

        120: "资料驳回",
        200: "投保成功",
        201: "投保成功(待补充资料)",

        // 210: "投保成功等待资料确认",
        210: "核保中",

        300: "投保失败",
        400: "退款中",
        500: "已退款",
        600: "退款成功",
        700: "已退保",
        800: "订单关闭",
        900: "保单失效"
    },
    // 操作人和投保人关系 groupApplicant-operatorRelation
    operatorRelationList: [
        { label: '法人', value: 1 },
        { label: '员工', value: 2 },
        { label: '授权代理人', value: 3 },
    ],
    //根据不同的保险期间计算不同的保险止期
    INSURANCE_END_TIME: {
        '1个月': {
            fn: 'addMonth',
            args: [1]
        },
        '2个月': {
            fn: 'addMonth',
            args: [2]
        },
        '3个月': {
            fn: 'addMonth',
            args: [3]
        },
        '4个月': {
            fn: 'addMonth',
            args: [4]
        },
        '5个月': {
            fn: 'addMonth',
            args: [5]
        },
        '6个月': {
            fn: 'addMonth',
            args: [6]
        },
        '12个月': {
            fn: 'addYear',
            args: [1]
        }
    },
    // 建工险 施工资质
    GROUP_NATURE_CONSTRUCTIONQUALIFICATION: [
      {key: 1, value: '一级施工资质'},
      {key: 2, value: '二级施工资质'},
      {key: 3, value: '三级施工资质'},
      {key: 4, value: '劳务施工不分等级'},

    ],
    GROUP_NATURE_PROJECTTYPES: [
      {key: 1, value: '室内装修工程（无室外）'},
      {key: 2, value: '楼宇等其他民用建筑工程'}
    ],
    GROUP_NATURE_typeOfLaborS: [
      {key: 1, value: '劳务分包工程（非劳务清包）'},
      {key: 2, value: '非劳务分包工程'}
    ]

}




// WEBPACK FOOTER //
// ./src/util/static-data.js